const home = {
  "hero.title_line1": "USFans Spreadsheet",
  "hero.title_line2": "Polska — Największa baza arkuszy i rankingów 2026",
  "hero.subtitle": "Odkryj najlepsze arkusze USFans, porównania twórców, rankingi i aktualne przewodniki. Wszystko, czego potrzebujesz, aby podjąć świadomą decyzję.",
  "hero.category_label": "Kategorie",
  "hero.cta_primary": "Sprawdź najnowszy USFans Spreadsheet",
  "hero.cta_secondary": "Porównaj arkusze",

  "benefits.title": "Dlaczego USFans Spreadsheet?",
  "benefits.subtitle": "Poznaj kluczowe zalety największej bazy arkuszy USFans w Polsce",
  "benefits.card1_title": "Codzienne Aktualizacje",
  "benefits.card1_desc": "Nasza baza arkuszy USFans jest aktualizowana każdego dnia, dzięki czemu zawsze masz dostęp do najświeższych rankingów i danych.",
  "benefits.card2_title": "Pełne Bezpieczeństwo",
  "benefits.card2_desc": "Weryfikujemy każde źródło informacji o USFans Spreadsheet. Nie przechowujemy żadnych danych użytkowników — Twoja prywatność jest dla nas priorytetem.",
  "benefits.card3_title": "Eksperckie Przewodniki",
  "benefits.card3_desc": "Nasz zespół ekspertów przygotowuje szczegółowe poradniki i analizy, które pomogą Ci zrozumieć każdy aspekt arkuszy USFans.",

  "comparison.title": "USFans Spreadsheet — Porównanie",
  "comparison.subtitle": "Zobacz, jak wypada USFans Spreadsheet na tle innych rozwiązań",
  "comparison.col_feature": "Funkcja",
  "comparison.col_usfans": "USFans Spreadsheet",
  "comparison.col_alternatives": "Alternatywy",
  "comparison.row1_feature": "Aktualizacje",
  "comparison.row1_usfans": "Codziennie",
  "comparison.row1_alt": "Co tydzień / miesiąc",
  "comparison.row2_feature": "Ilość danych",
  "comparison.row2_usfans": "10 000+ arkuszy",
  "comparison.row2_alt": "1 000 - 3 000",
  "comparison.row3_feature": "Weryfikacja",
  "comparison.row3_usfans": "Ekspercka",
  "comparison.row3_alt": "Społecznościowa",
  "comparison.row4_feature": "Bezpieczeństwo",
  "comparison.row4_usfans": "Brak przechowywania danych",
  "comparison.row4_alt": "Zbiera dane",
  "comparison.row5_feature": "Dostępność",
  "comparison.row5_usfans": "24/7 online",
  "comparison.row5_alt": "Ograniczona",
  "comparison.row6_feature": "Język polski",
  "comparison.row6_usfans": "Tak",
  "comparison.row6_alt": "Rzadko",

  "categories.title": "Popularne Kategorie",
  "categories.subtitle": "Przeglądaj produkty według kategorii w USFans Spreadsheet",

  "articles.title": "Najnowsze Artykuły",
  "articles.subtitle": "Przewodniki i analizy o USFans Spreadsheet",
  "articles.card1_title": "USFans Spreadsheet — Kompletny Przewodnik 2026",
  "articles.card1_desc": "Wszystko, co musisz wiedzieć o USFans Spreadsheet. Od podstaw po zaawansowane funkcje.",
  "articles.card1_link": "Czytaj więcej",
  "articles.card2_title": "7 powodów, dla których USFans Spreadsheet rośnie w 2026",
  "articles.card2_desc": "Dlaczego coraz więcej osób wybiera USFans Spreadsheet? Sprawdź kluczowe powody.",
  "articles.card2_link": "Czytaj więcej",
  "articles.card3_title": "Czy warto korzystać z USFans Spreadsheet?",
  "articles.card3_desc": "Szczera analiza zalet i wad. Porównanie z alternatywami na rynku.",
  "articles.card3_link": "Czytaj więcej",

  "trust.title": "Zaufanie i Bezpieczeństwo",
  "trust.subtitle": "Dlaczego możesz nam zaufać",
  "trust.desc": "Redakcja USFans Polska działa od 2026 roku, dostarczając rzetelnych informacji o arkuszach USFans. Nie przechowujemy danych użytkowników, nie wymagamy rejestracji i nie sprzedajemy informacji osobom trzecim. Każdy arkusz jest weryfikowany przez nasz zespół ekspertów przed publikacją.",
  "trust.author": "Redakcja USFans Polska",
  "trust.updated": "Ostatnia aktualizacja: Czerwiec 2026",

  "faq.title": "Najczęściej Zadawane Pytania",
  "faq.subtitle": "Wszystko o USFans Spreadsheet",
  "faq.q1": "Czym jest USFans Spreadsheet?",
  "faq.a1": "USFans Spreadsheet to kompleksowa baza arkuszy i rankingów, która gromadzi najważniejsze dane w jednym miejscu. To narzędzie stworzone z myślą o użytkownikach, którzy chcą szybko porównywać i analizować informacje bez konieczności przeszukiwania wielu źródeł.",
  "faq.q2": "Czy USFans Spreadsheet jest bezpieczny?",
  "faq.a2": "Tak, USFans Spreadsheet jest całkowicie bezpieczny. Nie przechowujemy żadnych danych osobowych użytkowników, nie wymagamy rejestracji i nie udostępniamy informacji podmiotom trzecim. Korzystanie z naszego przewodnika jest anonimowe i bezpieczne.",
  "faq.q3": "Jak często aktualizowany jest USFans Spreadsheet?",
  "faq.a3": "USFans Spreadsheet jest aktualizowany codziennie. Nasz zespół na bieżąco monitoruje zmiany i dodaje nowe arkusze oraz rankingi, aby zapewnić najświeższe informacje.",
  "faq.q4": "Czy USFans Spreadsheet jest darmowy?",
  "faq.a4": "Nasz przewodnik i porównania są całkowicie darmowe. Aby uzyskać pełny dostęp do wszystkich funkcji USFans Spreadsheet na głównej platformie, przejdź do kaspreadsheet.com.",
  "faq.q5": "Jak mogę porównać różne arkusze USFans?",
  "faq.a5": "Na naszej stronie znajdziesz szczegółowe tabele porównawcze. Możesz również skorzystać z kategorii produktów, aby przeglądać arkusze według typu. Dla pełnego porównania odwiedź naszą stronę główną kaspreadsheet.com.",
  "faq.q6": "Gdzie mogę kupić USFans Spreadsheet?",
  "faq.a6": "USFans Spreadsheet jest dostępny na stronie kaspreadsheet.com. Kliknij przycisk „Kup teraz” lub „USFans Spreadsheet” w górnym menu, aby przejść bezpośrednio do sklepu.",

  "cta.title": "Gotowy, aby odkryć USFans Spreadsheet?",
  "cta.subtitle": "Dołącz do tysięcy zadowolonych użytkowników. Sprawdź najnowsze rankingi i arkusze już dziś.",
  "cta.button": "Przejdź do USFans Spreadsheet",
};

export default home;